module.exports = __webpack_public_path__ + "media/images/num2_ic-on-c65a9acb9d5cb1ef4809f0fd2c18e5d2.svg";